import axiosInstance from "../utils/axiosInstance";
import {appUrls} from "../helpers/Urls";

export const DashboardApi = async () => {
  const result = await axiosInstance.get(appUrls.agentDashboard)
    return result.data
}
